import { Injectable, Injector } from "@angular/core";
import { BaseResourceService, CompraStorage } from "eddydata-lib";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CompraStorageService extends BaseResourceService<CompraStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`compra-storages`, injector);
  }

  public upload(arquivos: any[], orgao: number, compra: number, descricao?: string): Observable<CompraStorage[]> {
    const formData = new FormData();
    for (let arquivo of arquivos) {
      formData.append('files', arquivo);
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<CompraStorage[]>(`${this.login.cidade.id}/${this.api}/upload/${orgao}/${compra}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}